import React from "react";
import { Grid, GridColumn, GridRow } from "@/components/bp/bp-ui";

interface AuthLayoutRowProps {
    centered?: boolean;
    children: React.ReactNode;
}

export const AuthLayoutRow: React.FC<AuthLayoutRowProps> = ({ children, centered }) => {
    return (
        <GridRow>
            <GridColumn mobile={16} tablet={8} computer={6} textAlign={centered ? 'center' : undefined}>
                {children}
            </GridColumn>
        </GridRow>
    );
};
